import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_5: FaireProductEntity = {
  token: "driftless-studios-5",
  type: "product",
  name: "Pantry Open 24-7 Kitchen Sign - 24x6",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/364cfae10acb9233b678337fef94887b9b6be978ba18b1eb27409300cceb73d5.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 16.5,
  msrpDollars: 28,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
